var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCartOff = function SvgShoppingCartOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shopping_cart_off_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shopping_cart_off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.825 13-2-2h1.725l2.75-5H8.825l-2-2H19.95q.575 0 .887.487.313.488.013 1.063l-3.55 6.4a2.07 2.07 0 0 1-.713.775q-.437.275-.762.275M7 22q-.824 0-1.412-.588A1.93 1.93 0 0 1 5 20q0-.824.588-1.413A1.93 1.93 0 0 1 7 18q.824 0 1.412.587Q9 19.175 9 20t-.588 1.412A1.93 1.93 0 0 1 7 22m12.8.6L14.15 17H7.6q-1.1 0-1.675-.938T5.85 14.1l1.05-2.15L5.1 7.9 1.4 4.2a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l18.4 18.4q.275.274.288.687a.93.93 0 0 1-.288.713.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275M12.15 15l-2-2H8.6l-1 2zM17 22q-.825 0-1.412-.588A1.93 1.93 0 0 1 15 20q0-.824.588-1.413A1.93 1.93 0 0 1 17 18q.824 0 1.413.587Q19 19.175 19 20t-.587 1.412A1.93 1.93 0 0 1 17 22"
  }))));
};
export default SvgShoppingCartOff;